import { createSlice } from '@reduxjs/toolkit';
import { isNull } from 'lodash';

import { TPropertyValue } from '../../models/response/CarDetailResponse';

import { IInspection } from './inspection';

const initialState: IInspection.TInitialState = {
  answers: {
    variant_exact_model: null,
    accident_history: false,
    balance_owed: null,
    balance: null,
    body: 'sedan',
    car_keys: 1,
    color: 4,
    drive: '2wd',
    engine_cylinders: 4,
    engine_size: null,
    fuel_type: 1,
    gcc_specifications: true,
    interior_trim: 'fabric',
    manufacture_time: null,
    mileage: null,
    mileage_unit: 2,
    on_finance: false,
    paint: null,
    roof: 'regular',
    plate_number: null,
    seat_colors: 10,
    service_contract_expire_date: null,
    service_history: false,
    service_type: null,
    smc: false,
    smc_form: {
      mileage: null,
      date: '',
    },
    transmission: 'automatic',
    vehicle_location: {
      address: null,
      city_id: null,
      province_id: null,
    },
    vehicle_owner_family_member_or_friend: {
      first_name: null,
      last_name: null,
    },
    vehicle_owner: false,
    vehicle_owner_someone_else: null,
    vin_number: null,
    vin_plate: true,
    warning_lights: ['none'],
    warranty: false,
    warranty_expire_date: '',
    warranty_expire_mileage: null,
    number_of_seats: 5,
    number_of_tyres: 4,
    rim_type: 'alloy',
  },
  isShowError: false,
  elementError: null,
  isValid: true,
};

const inspection = createSlice({
  name: 'self-inspection',
  initialState,
  reducers: {
    setAnswers: (state, action) => {
      state.answers = { ...state.answers, ...action.payload };
    },
    setValue: (state, action) => {
      const {
        property_value,
        value,
        name,
      }: { property_value: TPropertyValue; value: string | number | null; name: string } =
        action.payload;

      if (state.answers) {
        if (property_value) {
          (state.answers as any)[property_value][name] = value;
        } else {
          (state.answers as any)[name] = value;
        }
      }
    },
    onToggleIsShowError: (state, action) => {
      state.isShowError = action.payload;
    },
    onToggleIsValid: (state, action) => {
      state.isValid = action.payload;
    },
    setErrors: (state, action) => {
      state.elementError = state.elementError
        ? !state.elementError.includes(action.payload)
          ? [...state.elementError, action.payload]
          : state.elementError
        : [action.payload];
    },
    setErrorsArray: (state, action) => {
      state.elementError = action.payload;
    },
    removeErrors: (state, action) => {
      const newValue = state.elementError?.filter((item) => item !== action.payload) || null;
      state.elementError = newValue?.length === 0 ? null : newValue;
      if (isNull(newValue)) state.isValid = true;
    },
    reset: () => initialState,
  },
});

export const {
  setAnswers,
  setValue,
  onToggleIsShowError,
  setErrors,
  removeErrors,
  onToggleIsValid,
  setErrorsArray,
  reset,
} = inspection.actions;

export default inspection.reducer;
